<script>
import { mapState } from 'vuex'
import Login from '@/components/login/VLogin'

export default {
  name: 'Pesquisa',
  components: {
    Login
  },
  methods: {

  },
  computed: {
    ...mapState({
      usuario: state => state.moduleLogin.usuario,
      user: state => state.moduleLogin.user
    })
  }
}
</script>

<template>
  <div class="row pesquisaContainer">
    <Login/>
    <span> {{ usuario && usuario.codUsuario > 0 ? $router.push('/home') : ''}} </span>
  </div>
</template>

<style scoped>
  .pesquisaContainer {
    height: 94%;
    text-align: center;
    width: 100vw;
    margin-left: 0px;
    margin-right: 0px;
  }
</style>
